import { OutputAreaSelect } from "./OutputAreaDetailView/OutputAreaDetailView";
import { SelectionFeature } from "src/js/stores/map/store";
import { useSiteReportConfiguration } from "react-migration/layouts/SiteReport/useSiteReportConfiguration/useSiteReportConfiguration";
import { useCallback } from "react";
import { useSiteReportDemographicsContext } from "./DemographicsProvider";

interface DemographicsExtraControlsProps {
  siteId: string;
  selectionFeature: SelectionFeature;
}

export function DemographicsExtraControls({ siteId, selectionFeature }: DemographicsExtraControlsProps) {
  const [siteReportConfiguration, { setConfiguration }] = useSiteReportConfiguration(siteId);
  const comparisonRegionId = siteReportConfiguration.demographicsComparisonRegionId;

  const { targetDesignation, comparableDesignations, regionHierarchy, defaultDesignationId, loading } =
    useSiteReportDemographicsContext();

  const setComparisonRegionId = useCallback(
    (value: string) => {
      setConfiguration({
        ...siteReportConfiguration,
        demographicsComparisonRegionId: value,
      });
    },
    [siteReportConfiguration, setConfiguration]
  );

  const setComparisonRegionIdCallback = useCallback(
    (value: string) => {
      setComparisonRegionId(value);
    },
    [setComparisonRegionId]
  );

  if (loading) {
    return null;
  }

  if (!targetDesignation) {
    return null;
  }

  return (
    <OutputAreaSelect
      value={comparisonRegionId || defaultDesignationId || ""}
      setValue={setComparisonRegionIdCallback}
      disabled={comparableDesignations.length <= 1}
      superiorOutputAreas={comparableDesignations}
      outputAreaCategoryHierarchy={regionHierarchy}
    />
  );
}
